import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { Agency, Agent, AgentKeys } from '@ag-common-lib/public-api';

export interface HierarchyChange {
  [BaseModelKeys.dbId]: string;
  [AgentKeys.manager_id]?: string;
  [AgentKeys.p_mga_id]?: string;
}

export enum AgencyHierarchyManagerMode {
  agentTransfer = 'agentTransfer',
  agencyTransfer = 'agencyTransfer',
  default = 'default',
}

export interface TransferConfig {
  originMga?: Agency;
  targetMga?: Agency;
  transferedAgent?: Agent;
  transferedAgency?: Agency;
  defaultHierarchyChanges?: Agent[][];
}

export interface TransferLeadSelection {
  targetMgaDbId: string;
  targetMgaLeadAgentId: string;
}

export interface TransferTeamResultData {
  hierarchyChanges: Record<string, Agent>;
  targetMgaLeadSelection?: TransferLeadSelection;
}

export interface PreparedHierarchyChanges {
  changes: Agent[];
  sourceAgentName: string;
}

export interface HierarchyItem {
  agent: Agent;
  teamMembers: HierarchyItem[];
  isShadowLead?: boolean;
}

export interface MgaHierarchy {
  mgaLead: HierarchyItem;
  freeAgents: HierarchyItem[];
  freeAgentSize: number;
  structuredAgents: HierarchyItem[];
  agentsByAgentIdMap: Map<string, Agent>;
  hierarchyMap: Map<string, HierarchyItem[]>;
}
